export const classes = {
  wrapper:
    'relative max-w-[75px] max-h-[75px] m-1 rounded-lg bg-grey-2 dark:bg-white/[0.06] place-center overflow-hidden',
  img: 'max-w-full max-h-full',
  overlay:
    'absolute top-0 right-0 size-full place-center opacity-0 hover:opacity-100 transition-opacity text-white px-2',
  withDelete: 'justify-between',
  icon: 'text-2xl cursor-pointer',
};

export const styles = {
  overlay: {
    backgroundColor: 'hsla(210, 20%, 15%, 0.5)',
  },
};
